import consts from "../consts";
import Model from "../models/model";

const model = new Model({
	name: 'TrackCycleFile',
	idProperty: '_id',
	disableAdd: true,
	readOnly: true,
	gridTitle: 'cycleHistory',
	gridRefreshInterval: 300000,
	showGridRefreshBtn: true,
	extraExportConfig: {
		PDF: {
			pageSize: 'A2'
		}
	},
	columns: [
		{ field: 'ClientName', width: 200 },
		{ field: 'RawFileName', header: 'rawFileName', width: 400 },
		{ field: 'ConvertFileName', header: 'convertFileName', width: 400 },
		{ field: 'SerialNumber', header: 'SerialNumber', width: 400 },
		{ field: 'CycleCount', header: 'CycleCount', width: 100, align: 'right' },
		{ field: 'Topic', width: 300, header: 'Topic' },
		{ field: 'PublishedAtCAT', header: 'publishedAtCAT', width: 200, type: 'dateTime', isLocal: true, format: consts.MomentFormat.DateTimeFormatAMPM },
		{ field: 'ReceivedAtBroker', header: 'receivedAtBroker', width: 200, type: 'dateTime', isLocal: true, format: consts.MomentFormat.DateTimeFormatAMPM },
		{ field: 'PublishedAtBroker', header: 'publishedAtBroker', width: 200, type: 'dateTime', isLocal: true, format: consts.MomentFormat.DateTimeFormatAMPM },
		{ field: 'MovedToCatSyncFolder', header: 'movedToCatSyncFolder', width: 200, type: 'dateTime', isLocal: true, format: consts.MomentFormat.DateTimeFormatAMPM },
		{ field: 'MovedToFinalXMLDirectoryAt', header: 'movedToFinalXMLDirectoryAt', width: 200, type: 'dateTime', isLocal: true, format: consts.MomentFormat.DateTimeFormatAMPM },
		{ field: 'UploadedToCATAPIAt', header: 'uploadedToCATAPIAt', width: 200, type: 'dateTime', isLocal: true, format: consts.MomentFormat.DateTimeFormatAMPM },
	]
});

export default model;
